/**
 * Working-day math for the scheduling heatmap.
 *
 * Context (T2-65): the heatmap distributes a task's forecast across a person's working days as
 * `forecast * workingDaysInLoop / workingDaysInTask`. Two inputs were unguarded, letting NEGATIVE
 * allocations surface on the People Schedule:
 *   1. A structurally non-working day (working minutes === 0) was counted as "time off" whenever a
 *      time-off allocation carried any minutes on it (e.g. HiBob-synced PTO on a day off).
 *   2. `workingDays - dayOffDays` was never clamped, so the count could go negative. A holiday on a
 *      non-working day is added to the day-off set unconditionally, so this clamp — not (1) — is the
 *      universal guard.
 */

// A time-off allocation only turns a day into a full day off if the person actually works that day.
// On a non-working day (workingMinutesOnDay === 0) time off must NOT count, or the day gets
// double-counted and downstream working-day counts go negative.
export const isFullDayOff = (workingMinutesOnDay: number, allocationMinutesOnDay: number): boolean =>
	workingMinutesOnDay > 0 && allocationMinutesOnDay >= workingMinutesOnDay;

// Working days left after removing day-off (time-off / holiday) days. Never negative.
export const getWorkingDayCount = (workingDaysInRange: number, dayOffDaysInRange: number): number =>
	Math.max(0, workingDaysInRange - dayOffDaysInRange);
